import script from "./VTableDataSet.vue?vue&type=script&setup=true&lang=ts"
export * from "./VTableDataSet.vue?vue&type=script&setup=true&lang=ts"

import "./VTableDataSet.vue?vue&type=style&index=0&id=58cbe109&lang=scss"

const __exports__ = script;

export default __exports__